import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { CalendarDays, ChevronRight, ArrowLeft } from "lucide-react";
import Layout from "../components/Layout";
import Seo from "../seo/Seo";
import { newsArticleGraph } from "../seo/jsonld";
import { news } from "../mock";

const NewsArticlePage = () => {
  const { slug } = useParams();
  const post = news.find((n) => n.slug === slug);
  if (!post) return <Navigate to="/aktuality" replace />;

  const title = `${post.title} | Ján Kuráň Ružomberok`;

  return (
    <Layout>
      <Seo title={title} description={post.excerpt} path={`/aktuality/${post.slug}`} image={post.image} jsonLd={newsArticleGraph(post)} />

      <article className="bg-campaign-cream">
        <div className="bg-campaign-blue px-4 sm:px-6 py-12 sm:py-16">
          <div className="max-w-3xl mx-auto">
            <nav aria-label="Omrvinková navigácia" className="text-campaign-cream/70 text-sm font-semibold mb-6 flex items-center gap-1 flex-wrap">
              <Link to="/" className="hover:text-campaign-yellow">Domov</Link>
              <ChevronRight size={14} />
              <Link to="/aktuality" className="hover:text-campaign-yellow">Aktuality</Link>
              <ChevronRight size={14} />
              <span className="text-campaign-yellow">{post.title}</span>
            </nav>
            <span className="inline-flex items-center gap-1.5 text-campaign-yellow text-xs font-bold uppercase mb-3">
              <CalendarDays size={14} /> {post.dateLabel}
            </span>
            <h1 className="font-display text-3xl sm:text-5xl text-campaign-cream leading-tight uppercase">
              {post.title}
            </h1>
          </div>
        </div>

        <div className="px-4 sm:px-6 py-10 sm:py-14">
          <div className="max-w-3xl mx-auto">
            <img src={post.image} alt={post.title} className="w-full h-64 sm:h-96 object-cover border-4 border-campaign-ink mb-8" />
            {post.body.map((p, i) => (
              <p key={i} className="text-campaign-ink/85 leading-relaxed mb-4 text-lg">{p}</p>
            ))}
            <Link to="/aktuality" className="mt-6 inline-flex items-center gap-1 font-semibold text-campaign-blue hover:underline">
              <ArrowLeft size={16} /> Späť na aktuality
            </Link>
          </div>
        </div>
      </article>
    </Layout>
  );
};

export default NewsArticlePage;
